import { VStack } from 'tio-ui/components/layout';
import ProgramGuidedWizard from 'tio-employee/components/tas/programs/guided/wizard';
import type { TOC } from '@ember/component/template-only';
import type { TasGroup as TasGroupModel } from 'tio-data/data/resources/tas-group.type';
import type { TasProgramInstanceExtension as TASProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';
import type { TasUnifiedInstitution as TasUnifiedInstitutionModel } from 'tio-data/data/resources/tas-unified-institution.type';

export interface S {
  Args: {
    model: {
      activeInstances: TASProgramInstanceModel[];
      programInstance: TASProgramInstanceModel;
      selectedSchool: TasUnifiedInstitutionModel | undefined;
      tasGroups: TasGroupModel[];
    };
  };
}

const tmpl: TOC<S> = <template>
  <VStack>
    <ProgramGuidedWizard @model={{@model}} />
  </VStack>
</template>;

export default tmpl;
